<template>
  <div class="ui small modal" ref="modal">
    <i class="close icon"></i>
    <div class="icon header">
      <i class="horse head icon"></i>
      {{ $t("choose starting point") }}
    </div>
    <div class="image scrolling content">
      <div class="ui small image">
        <img src="/images/icons/start_process.png" />
      </div>
      <div class="description">
        <div class="ui relaxed divided selection list">
          <div
            class="item"
            v-for="(start_event, sidx) in start_events"
            :key="sidx"
            @click="select_start(start_event)"
          >
            <i class="play middle aligned icon"></i>
            <div class="content">
              <a class="header">{{ start_event.name }}</a>
              <!-- <div class="description">Updated 10 mins ago</div> -->
            </div>
          </div>
        </div>
        <!-- <pre>{{ start_events }}</pre> -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "NgineWorkspaceStartModalStartingPointSelection",
  components: {},
  computed: {},
  data() {
    return {
      start_events: [],
      process: undefined,
      target: undefined,
    };
  },
  methods: {
    show_modal(options) {
      let vm = this;
      vm.start_events = options.start_events;
      vm.process = options.process;
      vm.target = options.target;
      window
        .jQuery(vm.$refs.modal)
        .modal({
          allowMultiple: true,
        })
        .modal("show");
    },
    select_start(start_event) {
      let vm = this;
      // console.log("start_event", start_event);
      vm.$emit("start_event_selected", {
        start_event: start_event,
        process: vm.process,
        target: vm.target,
      });
      window.jQuery(vm.$refs.modal).modal("hide");
    },
  },
  mounted() {},
  watch: {},
  updated: function () {},
};
</script>
